import type { infer as zInfer } from "zod/v4";
import { object, enum as zEnum } from "zod/v4";

export const setBigcommerceRefundMethod = {
  name: "setBigcommerceRefundMethod" as const,
  input: object({ refundMethod: zEnum(["default", "noop"]) }),
  output: object({ success: object({}).optional() }),
};

export type SetBigcommerceRefundMethodInput = zInfer<
  typeof setBigcommerceRefundMethod.input
>;
export type SetBigcommerceRefundMethodOutput = zInfer<
  typeof setBigcommerceRefundMethod.output
>;
